var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7273 9.81803L14.1819 11.2727L17.8185 7.63611L16.3639 6.18149L12.7273 9.81803ZM12.7273 14.1819L16.3639 17.8184L17.8185 16.3638L14.1819 12.7273L12.7273 14.1819ZM12 10.5453L7.63614 6.18149L6.18152 7.63611L10.5454 12L6.18152 16.3638L7.63614 17.8184L12 13.4546L13.4546 12L12 10.5453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4a7e5d722118490caf97ab402a97893e.svg";
export { ForwardRef as ReactComponent };